import { useUnit } from 'effector-react';
import _ from 'lodash';
import { $global } from 'models/store-global';
import { Alert } from 'react-bootstrap';
import styled from 'styled-components';

import AlertsService from 'services/AlertsService';

const Alerts = () => {
    const alerts = useUnit($global.map((state) => state.alerts || {}));

    const handlers = {
        hideAlert: (id: string) => () => {
            AlertsService.hideAlert(id);
        },
    };

    return (
        <>
            {_.keys(alerts).map((id, index) => {
                const alert = alerts[id];
                if (!alert) {
                    return null;
                }
                return (
                    <StyledAlert
                        key={id}
                        show={alert.show !== false}
                        variant={alert.variant ?? 'info'}
                        onClose={handlers.hideAlert(id)}
                        dismissible
                        index={index}
                    >
                        {alert.component ?? alert.message ?? ``}
                    </StyledAlert>
                );
            })}
        </>
    );
};

const StyledAlert = styled(Alert)<{ index: number }>`
    position: fixed;
    z-index: 5000;
    left: 50%;
    transform: ${({ index }) => `translate(-50%, calc(${index} * 100% + ${index + 1} * 5px))`};
    transition: 0.2s;

    button.close {
        min-width: unset;
    }

    @media (max-width: 480px) {
        width: 96%;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    width: 100vw;
    top: 15px;
    z-index: 1060;
    position: fixed;

    > * {
        max-width: 90vw;
    }
`;

export default Alerts;
